import { useState } from 'react';
import { TextField } from '@mui/material';
import DesignationButton from './DesignationButton';
import CustomMenu from '../common/CustomMenu';
import ActionDialog from '../dialog/ActionDialog';
import PinFIcon from '../../assets/pin_f_b3.svg';
import PinRIcon from '../../assets/pin_r_b3.svg';
import { useError } from '../../contexts/ErrorContext';

const RECOMMENDATION_COMMENT_MAX_LENGTH = 150;
const DEFAULT_RECOMMENDATION_POSITION = 999999;

const getRegionLabel = (displayRegion) => {
  if (displayRegion === 'KR') return '국내';
  return '해외';
};

const HomeAlbumFeatureButton = ({ albumInfo, onToggleLatest, onToggleRecommended }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isCommentDialogOpen, setIsCommentDialogOpen] = useState(false);
  const [recommendationComment, setRecommendationComment] = useState(
    albumInfo?.recommendationComment || '',
  );
  const [recommendationCommentEn, setRecommendationCommentEn] = useState(
    albumInfo?.recommendationCommentEn || '',
  );
  const { showError } = useError();
  if (!albumInfo) return null;

  const regionLabel = getRegionLabel(albumInfo.displayRegion);
  const isHomeRecommended =
    albumInfo.isRecommended &&
    albumInfo.homeRecommendationPosition < DEFAULT_RECOMMENDATION_POSITION;
  const designationType = albumInfo.homeAlbumSection
    ? 'FEATURED'
    : isHomeRecommended
      ? 'RECOMMENDED'
      : null;

  const menuItems = [
    ...(albumInfo.homeAlbumSection || regionLabel
      ? [
          {
            text: albumInfo.homeAlbumSection
              ? '홈 최신 앨범에서 해제'
              : `홈 최신 앨범 | ${regionLabel}에 고정`,
            onClick: () => {
              onToggleLatest?.();
              setAnchorEl(null);
            },
            icon: PinFIcon,
            iconAlt: 'Latest album feature',
          },
        ]
      : []),
    {
      text: isHomeRecommended ? '홈 포스트팝 추천 앨범에서 해제' : '홈 포스트팝 추천 앨범에 고정',
      onClick: () => {
        setAnchorEl(null);
        if (isHomeRecommended) {
          onToggleRecommended?.();
          return;
        }
        setRecommendationComment(albumInfo.recommendationComment || '');
        setRecommendationCommentEn(albumInfo.recommendationCommentEn || '');
        setIsCommentDialogOpen(true);
      },
      icon: PinRIcon,
      iconAlt: 'Recommended album feature',
    },
  ];

  return (
    <>
      <DesignationButton
        designationType={designationType}
        onToggle={(event) => setAnchorEl(event.currentTarget)}
      />
      <CustomMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        items={menuItems}
      />
      <ActionDialog
        open={isCommentDialogOpen}
        onClose={() => setIsCommentDialogOpen(false)}
        onConfirm={() => {
          if (
            recommendationComment.length > RECOMMENDATION_COMMENT_MAX_LENGTH ||
            recommendationCommentEn.length > RECOMMENDATION_COMMENT_MAX_LENGTH
          ) {
            showError('150자 이내로 작성해주세요.');
            return;
          }
          onToggleRecommended?.(recommendationComment, recommendationCommentEn);
          setIsCommentDialogOpen(false);
        }}
        title="홈 포스트팝 추천 앨범 고정"
        confirmText="고정"
      >
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          value={recommendationComment}
          onChange={(event) => setRecommendationComment(event.target.value)}
          placeholder="홈에 노출할 포스트팝 추천 코멘트를 입력하세요."
          helperText={`${recommendationComment.length}/${RECOMMENDATION_COMMENT_MAX_LENGTH}`}
          error={recommendationComment.length > RECOMMENDATION_COMMENT_MAX_LENGTH}
        />
        <TextField
          fullWidth
          multiline
          minRows={4}
          value={recommendationCommentEn}
          onChange={(event) => setRecommendationCommentEn(event.target.value)}
          placeholder="영문 포스트팝 추천 코멘트 (선택 · 비워두면 한국어 표시)"
          helperText={`${recommendationCommentEn.length}/${RECOMMENDATION_COMMENT_MAX_LENGTH}`}
          error={recommendationCommentEn.length > RECOMMENDATION_COMMENT_MAX_LENGTH}
          sx={{ mt: 2 }}
        />
      </ActionDialog>
    </>
  );
};

export default HomeAlbumFeatureButton;
